import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v1/styles/constants";
import { setFontStyle } from "@sellernote/ui/src/sds-v1/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.ul`
  ${mobile(css`
    background-color: ${COLOR.white};
    padding-bottom: 24px;
    border-bottom: 1px solid ${COLOR.grayScale_200};
  `)}

  li {
    padding: 0 8px;
  }

  li a {
    display: flex;
    align-items: center;
    ${setFontStyle("Body8")};
    color: ${COLOR.grayScale_600};
    padding: 8px 0;
  }

  li:nth-child(2) a {
    border-top: 1px solid ${COLOR.grayScale_200};
  }

  li > a > strong {
    display: block;
    padding: 4px;
    ${setFontStyle("Body8", "Bold")};
    background-color: ${COLOR.grayScale_300};
    color: ${COLOR.grayScale_600};
    border-radius: 4px;
    margin-right: 8px;
  }
`;

export default {
  container,
};
